import React from "react";
import classNames from "classnames";
import {FaCross} from "react-icons/fa6";
import {PiMusicNoteFill} from "react-icons/pi";

// Icon "Thánh Ca" cho Kristo Hymns — 2 icon rời ghép chồng (nốt nhạc nền lớn + thánh giá nhỏ đè góc
// dưới-phải), KHÔNG merge thành 1 path (khác approach B thử trước đó, xem git history) — giữ cấu trúc
// 2-icon, chỉ chỉnh màu/size/vị trí cho dễ nhìn:
// - noteColor (nền, indigo-600) và crossColor (thánh giá, amber-500) CHỦ Ý khác tông nhau — bản trước
//   cả 2 cùng fallback về 'currentColor' nên thánh giá lẫn vào nốt nhạc ở chỗ chồng lên nhau, không
//   phân biệt được (phản hồi thực tế "khó nhìn"). Amber cũng là tông accent đã dùng cho icon phụ ở
//   FamilyIcon/LearnPlayIcon/DirectoryIcon, giữ đồng nhất 1 tông "phụ" xuyên suốt.
// - Vị trí thánh giá dịch vào 1 chút (72%/72% thay vì 73%/76%) để nằm chắc trên phần thân đặc của nốt
//   nhạc, tránh lộ ra ngoài rìa glyph (vùng trong suốt quanh icon PiMusicNoteFill).
//
// `showCross`: true (mặc định) — tắt khi cần nốt nhạc trơn, không thánh giá (context nhỏ cạnh text,
// thánh giá gây rối ở size ~16) — xem StaticPrayerReader.js.
export const HymnIcon = ({
                              size = 32,
                              bgColor = null,          // truyền màu để có nền ô vuông, null = trong suốt (mặc định)
                              noteColor = '#4f46e5',   // indigo-600 — màu riêng "Thánh Ca", phân biệt gia đình
                              // (cam) / nhà thờ (teal) / học & chơi (tím)
                              crossColor = '#f59e0b',  // amber-500 — cùng tông accent icon phụ dùng chung toàn app
                              showCross = true,
                              className,
                              style,
                              ...props
                          }) => {
    const hasBg = bgColor && bgColor !== 'transparent';

    return (
        <div
            style={{
                width: size,
                height: size,
                backgroundColor: hasBg ? bgColor : 'transparent',
                ...style,
            }}
            className={classNames('relative flex-shrink-0 rounded-lg flex items-center justify-center', className)}
            {...props}>

            {/* Nốt nhạc — icon nền, chiếm gần trọn khung */}
            <PiMusicNoteFill
                size={size}
                style={{
                    color: noteColor,
                    position: 'absolute',
                    top: '50%',
                    left: '46%',
                    transform: 'translate(-50%, -50%)',
                }}
            />

            {showCross && (
                /* Thánh giá — đè góc dưới-phải, nằm trên phần thân đặc của nốt nhạc để không bị lẫn
                   vào nền trong suốt xung quanh */
                <FaCross
                    size={size * 0.42}
                    style={{
                        color: crossColor,
                        filter: 'drop-shadow(0px 1px 1px rgba(0,0,0,0.25))',
                        position: 'absolute',
                        top: '72%',
                        left: '72%',
                        transform: 'translate(-50%, -50%)',
                    }}
                />
            )}
        </div>
    );
};
